import React from "react";
import Panel from "./Panel";
import FormItem from "./FormItem";

import i18n from 'i18n-js';
import {Link} from "react-router";

import Chart from "./UI/Chart/Chart";


import {api, obsDataParser, formatQuestionResponse, parsePHPtime} from "./baseFunctions";
import langs from "./langs/phpIndex";
import phpLangs from "./langs/phpIndex";

import ChartMaker from "./UI/ChartMaker/ChartMaker";


import "./css/print.css";
import "./css/weeklyReport.css";

import "./css/publicReport.css";
export default class PublicReport extends React.Component {
	constructor(){
		super();
		this.state = {
            loading: true,
            data: false,
            users: [],
		};
	}

	componentDidMount(){
		if([...document.body.classList].indexOf("inReport") === -1)
		{
			document.body.classList.toggle("inReport");
        }
        this.getData();
    }
    
	componentDidUpdate(){
		if([...document.body.classList].indexOf("inReport") === -1)
		{
			document.body.classList.toggle("inReport");
    }
	}

	  componentWillUnmount(){
		// document.body.classList.toggle("inReport");
    }

    print()
    {
      if(document.URL.includes("?autoprint"))
      {
        window.print();
      }
    }
    
    getData()
    {
        const data = this.props.params;
        let myData = {"type": "getPublicReport", hash: data.hash, id: data.id};
        if(data.otherhash)
        {
          myData.historyHash = data.otherhash;
        }
        api("POST", myData, (d) => {
            if(d && !d.error)
            {
                const data = d.data;
                console.log("Data", data);
                this.setState({
                    data,
                    loading: false,
                });

                obsDataParser(data).then(data => {
                  this.setState({
                    data
                  });
                  setTimeout(() => this.print(), 1000);
                });
            }
        });
    }

    balticTemplate()
    {
      const phpLang = phpLangs[this.props.params.lang];
      const d = this.state.data;

      return (<page backtop="5mm" backbottom="5mm" backleft="5mm" backright="5mm">
      <h2>{d.name} #{d.id}</h2>
      <form className="form-horizontal form-label-left simpleTemplate" action="" method="post">
          <div className="item form-group">
              <div className="col-md-6 col-sm-6 col-xs-6">
                  <div className="fakeText">
                    {d.createdBy}
                  </div>
              </div>
              <div className="col-md-6 col-sm-6 col-xs-6">
                  <div className="fakeText">
                    {new Date(Number(d.stamp)).toLocaleDateString()}
                  </div>
              </div>
          </div>
          
          <table style={{width: "95%"}} className="publicReport">
            <tr>
            </tr>
            {
              d.questions.map(question => question.type === "upload" ? <tr>
              <td></td>
              <td className="biggerImages">
                  {
                        formatQuestionResponse(question, d.sheet.questions, this)
                  }
                  </td>
              </tr> : <tr>
                <td style={{minWidth: "50px"}}>{i18n.t(question.question)}</td>
                <td>
                    {
                          formatQuestionResponse(question, d.sheet.questions, this)
                    }
                    </td>
                </tr>)
            }
          </table>

          <h2 style={{marginTop: "20px"}}>{i18n.t("Historik")}</h2>
          <table className="table table-striped bulk_action">
              <thead>
                <tr className="headings">
                  <th className="column-title">{phpLang.ACTION}</th>
                  <th className="column-title">{phpLang.COMMENT}</th>
                  <th className="column-title">{phpLang.BY}</th>
                  <th className="column-title">{phpLang.RESPONSIBLE}</th>
                  <th className="column-title">{phpLang.STATUS}</th>
                  <th className="column-title">{phpLang.DATE}</th>
                </tr>
              </thead>
              <tbody>
                {
                  this.state.data.history.map((d, key) => 
                    <tr key={"history" + key} className="even">
                      <td>{phpLang[d.action]}</td>
                      <td>{d.comment}</td>
                      <td>{d.createdBy || d.externalName}</td>
                      <td>{d.owner === 31 ? d.externalName : d.ownerName}</td>
                      <td>{phpLang['STATUS_ARR'][d.status]}</td>
                      <td>{parsePHPtime(d.unix / 1000)}</td>
                    </tr>)
                }
                
              </tbody>
          </table>
           
      </form>
    </page>);
    }

    simpleTemplate()
    {
      const phpLang = phpLangs[this.props.params.lang];
      const d = this.state.data;

      return (<page backtop="5mm" backbottom="5mm" backleft="5mm" backright="5mm">
      <h1>{d.name} #{d.id}</h1>
      <form className="form-horizontal form-label-left simpleTemplate" action="" method="post">
          <div className="item form-group">
              <div className="control-label col-md-3 col-sm-3 col-xs-12" for="name">Lavet af </div>
              <div className="col-md-12 col-sm-12 col-xs-12">
                  <div className="fakeText">
                    {d.createdBy}
                  </div>
              </div>
          </div>
          <div className="item form-group">
              <div className="control-label col-md-3 col-sm-3 col-xs-12" for="name">Start tidspunkt </div>
              <div className="col-md-12 col-sm-12 col-xs-12">
                  <div className="fakeText">
                    {new Date(Number(d.stamp)).toLocaleDateString()}
                  </div>
              </div>
          </div>
    
          
          <table style={{width: "95%"}} className="publicReport">
            <tr>
            </tr>
            {
              d.questions.map(question => question.type === "upload" ? <tr>
              <td></td>
              <td className="biggerImages">
                  {
                        formatQuestionResponse(question, d.sheet.questions, this)
                  }
                  </td>
              </tr> : <tr>
                <td>{i18n.t(question.question)}</td>
                <td>
                    {
                          formatQuestionResponse(question, d.sheet.questions, this)
                    }
                    </td>
                </tr>)
            }
          </table>

          <h1 style={{marginTop: "20px"}}>{i18n.t("Historik")}</h1>
          <table className="table table-striped bulk_action">
              <thead>
                <tr className="headings">
                  <th className="column-title">{phpLang.ACTION}</th>
                  <th className="column-title">{phpLang.COMMENT}</th>
                  <th className="column-title">{phpLang.BY}</th>
                  <th className="column-title">{phpLang.RESPONSIBLE}</th>
                  <th className="column-title">{phpLang.STATUS}</th>
                  <th className="column-title">{phpLang.DATE}</th>
                </tr>
              </thead>
              <tbody>
                {
                  this.state.data.history.map((d, key) => 
                    <tr key={"history" + key} className="even">
                      <td>{phpLang[d.action]}</td>
                      <td>{d.comment}</td>
                      <td>{d.createdBy || d.externalName}</td>
                      <td>{d.owner === 31 ? d.externalName : d.ownerName}</td>
                      <td>{phpLang['STATUS_ARR'][d.status]}</td>
                      <td>{parsePHPtime(d.unix / 1000)}</td>
                    </tr>)
                }
                
              </tbody>
          </table>
           
      </form>
    </page>);
    }

    sallingTemplate()
    {
      const colorStatus = ["#FFF"];
      const d = this.state.data;
      // console.log("Data", d);
      
      
      const LANG = langs[this.props.params.lang];
      const phpLang = phpLangs[this.props.params.lang];

      const date = new Date(Number(d.stamp));
      // console.log("Salling", d.questions);
      return (<page backtop="5mm" backbottom="5mm" backleft="5mm" backright="5mm" className="public-report">
          <table style={{width: "100%"}}>
            <tr>
              <td colSpan={3}>
                <div className="sallingHeader">
                  <img src="/includes/sallingStar.png" className="sallingLogo"/>
                  <span style={{backgroundColor: colorStatus[0]}}>
                      Risk assessment<br/>Preventive Work Environment Action
                  </span>
                  <img src="/includes/sallingStar.png" className="sallingLogo"/>
                </div>
              </td>
              {/* <td className="logoContainer">
                <img src="/includes/sallingStar.png" className="sallingLogo"/>
              </td>
              <td className="center titleFont">
                <span style={{backgroundColor: colorStatus[0]}}>
                    Risk assessment<br/>Preventive Work Environment Action
                </span>
              </td>
              <td className="logoContainer">
                <img src="/includes/sallingStar.png" className="sallingLogo"/>
              </td> */}
            </tr>
            <tr>
              <td className="center borderBottom" colspan="3">
                HSE group records and processes events/observations!
              </td>
            </tr>
            <tr>
              <td className="centered" style={{width: "50%", borderTop: "0px"}}>
                <b>{LANG.DEPARTMENT}</b><br/>
                {d.departmentName}
              </td>
              <td></td>
              {/* <td className="centered" style={{width: "50%", borderTop: "0px"}}>
                <b>Place</b><br/>
                ADDDRESS_HERE
              </td> */}
            </tr>
        
            {/* <tr className="borderTop">
              <td className="centered" colspan="3">
                <b>Type of event</b><br/>
                incident_type
              </td>
            </tr>
            <tr className="borderTop">
              <td className="centered" colspan="3">
                <b>Description of observation</b><br/>
                desc_act
                </td>
            </tr> */}
          {/* $stmt2 = $db->query('SELECT * FROM uploads WHERE refID = "' . secure($showID) . '" ORDER BY id DESC LIMIT 2');
            if($stmt2->rowCount() > 0)
            {
                $height = "280px";
                $html .= '<tr>
              <td colspan="3" style="height: ' . $height . '; padding-bottom: 10px;"><div style="height: ' . $height . ';">';
                  while($row2 = $stmt2->fetch(PDO::FETCH_ASSOC)) 
                  {
                    $isBase64 = strpos($row2['base64'], "base64") !== false;
                      $html .= $isBase64 ? '<img style="max-height: ' . $height . '; width: 50%; float: left; "  src="' . $row2['base64'] .  '" />' : '<img style="max-height: ' . $height . '; width: 50%; float: left;" src="https://safeallday.dk/new/img/uploads/' . $row2['base64'] .  '" />';
                  }
        
              $html .= '</div></td></tr>';
            } */}
            {/* <tr className="borderTop">
              <td className="centered" colspan="3">
                <b>Immediate actions taken</b><br/>
                desc_init_act
              </td>
            </tr>
            <tr className="borderTop">
              <td className="centered" colspan="3">
                <b>Status</b><br/>
                status
              </td> 
            </tr> */}

            {
              d.questions.filter(q => q.type !== "mapPicker").map((question, key) => 
              <tr className="borderTop" key={key}>
                <td className="centered questionRow salling" colspan="3">
                  <b>{i18n.t(question.question)}</b><br/>
                  <div style={{display: "flex", justifyContent: "center"}}>
                    {
                          formatQuestionResponse({
                            ...question,
                            response: question.response.filter((d, i) => (question.type === "upload" && i < 2) || (question.type !== "upload"))
                          }, d.sheet.questions, this)
                    }
                  </div>
                </td>
              </tr>)
            }

            {/* {
                d.questions.map(question => <tr>
              <td>{question.question}</td>
              <td>
                  {
                        formatQuestionResponse(question, d.sheet.questions, this)
                  }
                  </td>
              </tr>)
            } */}
            <tr className="borderTop">
              <td className="centered" colspan="3">
                #{d.id}<br/>
                {date.toLocaleString()}
                {/* H:i:s Y-m-d */}
              </td>
            </tr>
        
          </table>


          {
            window.location.hash.includes("?showHistory") && <table className="table table-striped bulk_action">
              <thead>
                <tr className="headings">
                  <th className="column-title">{phpLang.ACTION}</th>
                  <th className="column-title">{phpLang.COMMENT}</th>
                  <th className="column-title">{phpLang.BY}</th>
                  <th className="column-title">{phpLang.RESPONSIBLE}</th>
                  <th className="column-title">{phpLang.STATUS}</th>
                  <th className="column-title">{phpLang.DATE}</th>
                </tr>
              </thead>
              <tbody>
                {
                  this.state.data.history.map((d, key) => 
                    <tr key={"history" + key} className="even">
                      <td>{phpLang[d.action]}</td>
                      <td>{d.comment}</td>
                      <td>{d.createdBy || d.externalName}</td>
                      <td>{d.owner === 31 ? d.externalName : d.ownerName}</td>
                      <td>{phpLang['STATUS_ARR'][d.status]}</td>
                      <td>{parsePHPtime(d.unix / 1000)}</td>
                    </tr>)
                }
                
              </tbody>
          </table>
          }
        
        </page>);
    }
  
    

	render(){
        if(this.state.loading)
        {
            return <div>Loading</div>;
        }
        const LANG = langs[this.props.params.lang];
        const phpLang = phpLangs[this.props.params.lang];

        const colorStatus = ["#FFF"];
        const d = this.state.data;
        const historyHash = this.props.params.otherhash;

        const repData = this.state.data;

        const LANG_TRANSLATOR = {
          "DK": "da-DK",
          "EN": "en-US",
        };
        i18n.locale = LANG_TRANSLATOR[this.props.params.lang] || "en-US";

        const templates = {
          18: () => this.sallingTemplate(),
          // 21: () => this.simpleTemplate(),
          21: () => this.balticTemplate(),
        };
        const template = templates[d.firmID];

        console.log("All questions", d);
        return <div className="printPagez">
          {template ? template() : (<page backtop="5mm" backbottom="5mm" backleft="5mm" backright="5mm">
        <h1>{d.name} #{d.id}</h1>
        <form className="form-horizontal form-label-left" action="" method="post">
            {/* <div className="item form-group">
                <div className="control-label col-md-3 col-sm-3 col-xs-12" for="name">Addresse </div>
                <div className="col-md-8 col-sm-8 col-xs-12">
                    <div className="fakeText">
                      ADDRESS
                    </div>
                </div>
            </div>
            <div className="item form-group">
                <div className="control-label col-md-3 col-sm-3 col-xs-12" for="name">Kunde
                </div>
                <div className="col-md-8 col-sm-8 col-xs-12">
                  <div className="fakeText">
                  COSTUMER
                  </div>
                </div>
            </div> */}
            <div className="item form-group">
                <div className="control-label col-md-3 col-sm-3 col-xs-12" for="name">Lavet af </div>
                <div className="col-md-12 col-sm-12 col-xs-12">
                    <div className="fakeText">
                      {d.createdBy}
                    </div>
                </div>
            </div>
            <div className="item form-group">
                <div className="control-label col-md-3 col-sm-3 col-xs-12" for="name">Start tidspunkt </div>
                <div className="col-md-12 col-sm-12 col-xs-12">
                    <div className="fakeText">
                      {new Date(Number(d.stamp)).toLocaleDateString()}
                    </div>
                </div>
            </div>
            {/* <div className="item form-group">
                <div className="control-label col-md-3 col-sm-3 col-xs-12" for="name">Slut tidspunkt </div>
                <div className="col-md-8 col-sm-8 col-xs-12">
                    <div className="fakeText">
                      <?php echo $row['finished'] == 1 ? gmdate("H:i:s Y-m-d", timeFix($row['time']) ) : "Ikke afsluttet"; ?>
                    </div>
                </div>
            </div> */}
      
            
           <h2>{i18n.t("Spørgsmål")}</h2>
            <table style={{width: "95%"}} className="publicReport">
              <tr>
                <td><b>{i18n.t("Spørgsmål")}</b></td>
                <td><b>{i18n.t("Svar")}</b></td>
              </tr>
              {
                d.questions.map(question => <tr>
              <td>{i18n.t(question.question)}</td>
              <td>
                  {
                        formatQuestionResponse(question, d.sheet.questions, this)
                  }
                  </td>
              </tr>)
              }
              {/* <?php
              $answer = array(
                "1" => "Ja",
                "2" => "Nej",
                "0" => "Nej",
              );
              foreach ($data['questions'] as $key => $question) {
                if($question['type'] === "RA_yesNo")
                {
                  echo '<tr>
                          <td>' . $question['texts'][$lang] . '</td>
                          <td>' . $answer[$question['value']] . '</td>
                        </tr>';
                }else if($question['type'] === "RA_inputs")
                {
                  foreach ($question['extra'] as $key => $ex) {
                     echo '<tr>
                          <td>' . $ex['value2'] . '</td>
                          <td>' . $ex['value']  . '</td>
                        </tr>';
                  }
                 
                }else if($question['type'] === "RA_signature")
                {
                  echo '<tr>
                          <td>' . $question['texts'][$lang] . '</td>
                          <td><img style="max-height:100px" src="https://safeallday.dk/new/img/uploads/' . $question['value'] . ' /></td>
                        </tr>';
                }else{
                  echo '<tr>
                          <td>' . $question['texts'][$lang] . '</td>
                          <td>' . $answer[$question['value']] . '</td>
                        </tr>';
                  //print_r($question);
                }
              }
              ?> */}
            </table>
             
        </form>
      </page>)}
              {
                historyHash && <div style={{marginTop: "20px"}}>
                  <div style={{overflow: "auto"}}>
                    {
                      d.validHash && 
                        <Panel title={phpLang['ACTION']}>
                          <form className="form-horizontal form-label-left" action="" method="post" onSubmit={(e) => {
                            e.preventDefault();
                            var data = {
                              status: this.refs.status.value,
                              owner: this.refs.users.value,
                              comment: this.refs.comment.value,

                              name: this.refs.name.value,
                              mail: this.refs.mail.value,
                            };

                            api("POST", {"type": "addReportHistory", id: this.props.params.id, historyHash, data}, (d) => {
                              //console.log(d);
                              if(!d.error)
                              {
                                alert(LANG['CHANGES_SAVED']);
                                this.refs.comment.value = "";
                                this.refs.name.value = "";
                                this.refs.mail.value = "";
                                // this.getOBS(this.props.params.id);
                                this.getData();
                              }
                            }, this.props.auth, 1);
                          }}>
                            <FormItem name={phpLang['STATUS']}>
                              <select className="form-control col-md-7 col-xs-12" name="status" ref="status">
                                {
                                  phpLang['STATUS_ARR'].filter((d, key) => key < 3).map((d, key) => <option key={"statusS" + key} value={key}>{d}</option>)
                                }
                              </select>
                            </FormItem>
                            <FormItem name={phpLang['ASSIGNED_TO']}>
                              <select className="form-control col-md-7 col-xs-12" name="users" ref="users" defaultValue={repData.assigned} onChange={(e) => {
                                this.refs.extraDiv.style.display = e.target.value === "-1" ? "initial" : "none";
                              }}>
                                <option value={""}>{phpLang['CURRENT']}</option>
                                <option value="-1">{phpLang['OTHER_CONTACT']}</option> 
                              {
                                this.state.users.map((d, key) => <option key={"user" + key} value={d.id}>{d.fullName}#{d.id}</option>)
                              }
                              </select>
                            </FormItem>
                            <div ref="extraDiv" style={{display: "none"}}>
                              <FormItem name={phpLang['NAME']}>
                                <input type="text" name="name" ref="name" className="form-control col-md-7 col-xs-12"/>
                              </FormItem>
                              <FormItem name={phpLang['MAIL']}>
                                <input type="text" name="mail" ref="mail" className="form-control col-md-7 col-xs-12"/>
                              </FormItem>
                            </div>
                            <FormItem name={phpLang['COMMENT']}>
                              <textarea className="form-control col-md-7 col-xs-12" name="comment" ref="comment"></textarea>
                            </FormItem>
                            <FormItem>
                              <button ref="send" type="submit" className="btn btn-success">{phpLang['CREATE']}</button>
                            </FormItem>
                          </form>
                        </Panel>
                    }
                  
                  </div>
                    <div className="table-responsive">
                      <table className="table table-striped jambo_table bulk_action">
                        <thead>
                          <tr className="headings">
                            <th className="column-title">{phpLang.ACTION}</th>
                            <th className="column-title">{phpLang.COMMENT}</th>
                            <th className="column-title">{phpLang.BY}</th>
                            <th className="column-title">{phpLang.RESPONSIBLE}</th>
                            <th className="column-title">{phpLang.STATUS}</th>
                            <th className="column-title">{phpLang.DATE}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            this.state.data.history.map((d, key) => 
                              <tr key={"history" + key} className="even">
                                <td>{phpLang[d.action]}</td>
                                <td>{d.comment}</td>
                                <td>{d.createdBy || d.externalName}</td>
                                <td>{d.owner === 31 ? d.externalName : d.ownerName}</td>
                                <td>{phpLang['STATUS_ARR'][d.status]}</td>
                                <td>{parsePHPtime(d.unix / 1000)}</td>
                              </tr>)
                          }
                          
                        </tbody>
                    </table>
                    </div>
                </div>
              }
        </div>;
	}
}


// WEBPACK FOOTER //
// ./src/components/PublicReport.js